<template>
  <div>
    <a-card style="margin-bottom: 10px">
      <div class="filter-section">
        <a-form layout="inline" ref="form" :model="form">
          <a-form-item label="状态" name="state">
            <a-select
              style="width: 140px"
              v-model:value="form.state"
            >
              <a-select-option key="">
                全部
              </a-select-option>
              <a-select-option v-for="item in labelState" :key="item.state">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="名称" name="name">
            <a-input style="width: 200px" placeholder="请输入名称" v-model:value="form.name" autocomplete="off">
            </a-input>
          </a-form-item>
          <!--<a-form-item label="搜索" name="name">
            <a-input style="width: 200px"
              placeholder="请输入名称"
              v-model:value="form.name">
              <template v-slot:suffix><search-outlined type="user"/></template>
            </a-input>
          </a-form-item>-->
          <a-form-item>
            <a-button @click="resetForm">重置</a-button>
            <a-button type="primary" @click="getData()">查询</a-button>
          </a-form-item>
        </a-form>
      </div>
    </a-card>
    <a-card>
      <a-table
        :columns="columns"
        :data-source="tableData"
        rowKey="id"
        :pagination="false">
        <template v-slot:taskType="{ text }">
          {{ getTaskName(text) }}
        </template>
        <template v-slot:userId="{ text }">
          {{ getUserName(text) }}
        </template>
        <template v-slot:stateName="{ record }">
          {{ record.locking == 'success' ? '任务处理中' : getStateName(record.state) }}
        </template>
        <template v-slot:pgress="{ text }">
          {{ getValue(text) }}
        </template>
        <template v-slot:time="{ text }">
          {{ getDateTime(text) }}
        </template>
        <template v-slot:finishTime="{ text }">
          {{ getDateTime(text) }}
        </template>
        <template v-slot:action="{ record }">
          <span class="gap-btn">
            <a @click="toDetail(record)">详情</a>
          </span>
          <span v-if="record.locking != 'success'">
          <span class="gap-btn" v-if="record.state == 'already_accept'">
            <a @click="handleSplit(record)">拆分</a>
          </span>
          <span class="gap-btn" v-if="(record.state != 'origin' && record.state != 'already_accept' && record.state != 'already_deny' && record.state != 'merge')">
            <a @click="handleSplitReset(record)">重新拆分</a>
          </span>
            </span>
          <span class="gap-btn">
            <a :class="(record.locking != 'success' && record.state != 'origin' && record.state != 'already_accept' && record.state != 'already_deny')?'':'grey'" @click="(record.locking != 'success' && record.state != 'origin' && record.state != 'already_accept' && record.state != 'already_deny')?toSubTask(record):''">查看子任务</a>
          </span>
         <!-- <span class="gap-btn">
            <a :class="record.state == 'already_annotation'?'':'grey'" @click="record.state == 'already_annotation'?handleAudit(record):''">审核</a>
          </span>-->
         <!-- <span class="gap-btn">
            <a :class="(record.state == 'already_annotation' || record.state == 'approval')?'':'grey'" @click="(record.state == 'already_annotation' || record.state == 'approval')?handleSubmit(record):''">任务提交</a>
          </span>-->
        </template>
      </a-table>
      <br>
      <a-pagination
        :current="page.pageNum"
        show-quick-jumper
        :pageSize="10"
        :total="total"
        :show-total="total => `共 ${total} 条`"
        @change="getData"
      ></a-pagination>
    </a-card>
    <group-task-detail ref="taskDetail" :current-item="currentItem"></group-task-detail>
    <SplitDialog ref="splitDialog" :current-item="currentItem" @refreshData="getData"></SplitDialog>
    <AuditDialog ref="auditDialog" :current-item="currentItem" @refreshData="getData"></AuditDialog>
  </div>
</template>
<script>
// import { SearchOutlined } from '@ant-design/icons-vue'
import { getMyRelease, updateTask } from '@/api/task'
import { getDateTime, getTaskName, getValue, getStateName, getUserName } from '@/filters'
import SplitDialog from './SplitDialog'
import AuditDialog from './AuditDialog'
import GroupTaskDetail from './GroupTaskDetail'
import { getAllData } from '@/api/dataSet'
const columns = [
  {
    title: '名称',
    dataIndex: 'name'
  },
  {
    title: '任务类型',
    dataIndex: 'taskTypeId',
    slots: { customRender: 'taskType' }
  },
  {
    title: '说明',
    dataIndex: 'description'
  },
  {
    title: '状态',
    // dataIndex: 'state',
    slots: { customRender: 'stateName' }
  },
  {
    title: '标注进度',
    dataIndex: 'progress',
    slots: { customRender: 'pgress' }
  },
  {
    title: '发布人',
    dataIndex: 'createUserId',
    slots: { customRender: 'userId' }
  },
  {
    title: '接收人',
    dataIndex: 'excuteUserId',
    slots: { customRender: 'userId' }
  },
  {
    title: '发布时间',
    dataIndex: 'createTime',
    slots: { customRender: 'time' }
  },
  {
    title: '要求完成时间',
    dataIndex: 'planFinishTime',
    slots: { customRender: 'finishTime' }
  },
  {
    title: '操作',
    slots: { customRender: 'action' }
  }
]

const data = [
  /* {
    id: 1,
    name: '任务1',
    type: '目标检测',
    description: '说明内容',
    time: '2020-10-15 20:00:00',
    demandTime: '2020-10-20 20:00:00',
    state: '已拒绝',
    creator: 'name1',
    progress: '0/246'
  },
  {
    id: 2,
    name: '任务2',
    type: '目标检测',
    description: '说明内容',
    time: '2020-10-15 20:00:00',
    demandTime: '2020-10-20 20:00:00',
    state: '已审核',
    creator: 'name1',
    progress: '0/246'
  },
  {
    id: 3,
    name: '任务3',
    type: '目标检测',
    description: '说明内容',
    time: '2020-10-15 20:00:00',
    demandTime: '2020-10-20 20:00:00',
    state: '标注中',
    creator: 'name1',
    progress: '0/246'
  } */
]
export default {
  components: {
    GroupTaskDetail,
    // SearchOutlined,
    SplitDialog,
    AuditDialog
  },
  data () {
    return {
      labelState: [
        { name: '待拆分', state: 'already_accept' },
        { name: '待分配', state: 'waiting_assign' },
        { name: '待标注', state: 'waiting_annotate' },
        { name: '标注中', state: 'doing_annotation' },
        { name: '已标注', state: 'already_annotation' }],
      form: {
        state: '',
        name: ''
      },
      tableData: data,
      columns,
      page: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      currentItem: {},
      taskTypes: [],
      addition: '',
      dataList: [],
      dataSetInfo: {}
    }
  },
  mounted () {
    this.getData(1)
    // this.getDataSetByPage(1)
  },
  methods: {
    getDateTime,
    getTaskName,
    getValue,
    getStateName,
    getUserName,
    resetForm () {
      this.$refs.form.resetFields()
    },
    getData (pageNum) {
      if (pageNum) this.page.pageNum = pageNum
      let s = ''
      if (this.form.state) {
        s = this.form.state
      } else {
        s = 'already_acceptviayieflagyieviawaiting_assignviayieflagyieviawaiting_annotateviayieflagyieviadoing_annotationviayieflagyieviaalready_annotation'
      }
      getMyRelease({ ...this.form, ...this.page, state: s, parentId: 'nullValue', field: 'createTime', order: 'desc' }).then(res => {
        const data = res.data.map.data
        this.total = data.total
        this.tableData = data.rows
      })
    },
    getDataSetByPage () {
      getAllData({ pageSize: 10000 }).then(res => {
        const data = res.data.map.data
        this.dataList = data.rows
      })
    },
    // 拆分
    handleSplit (item) {
      this.currentItem = item
      /*  const info = this.dataList.find(item => item.id === this.currentItem.datasetId)
      this.dataSetInfo = info
      this.addition = info.addition */
      this.$refs.splitDialog.open()
    },
    // 重新拆分
    handleSplitReset (item) {
      this.$confirm({
        title: '任务重置',
        content: '确认重新拆分任务？此操作将清空之前的标注结果',
        okText: '是',
        okType: 'danger',
        cancelText: '否',
        onOk: () => {
          this.currentItem = item
          this.currentItem.reset = true
          this.$refs.splitDialog.open()
        },
        onCancel () {
          console.log('cancel')
        }
      })
    },
    // 审核
    handleAudit (item) {
      this.currentItem = item
      const info = this.dataList.find(item => item.id === this.currentItem.datasetId)
      this.dataSetInfo = info
      this.addition = info.addition
      this.$refs.auditDialog.open()
    },
    // 提交
    handleSubmit (item) {
      this.$confirm({
        title: '任务提交',
        content: '确认任务已完成，并提交？',
        okText: '是',
        okType: 'danger',
        cancelText: '否',
        onOk: () => {
          updateTask({
            id: item.id, state: 'under_check'
          }).then(res => {
            this.$message.success('操作成功')
            this.getData(1)
          })
        },
        onCancel () {
          console.log('cancel')
        }
      })
    },
    toDetail (item) {
      this.currentItem = item
      /* const info = this.dataList.find(item => item.id === this.currentItem.datasetId)
      this.addition = info.addition
      this.dataSetInfo = info */
      this.$refs.taskDetail.open()
      // this.$router.push({ name: 'groupTaskDetail' })
    },
    toSubTask (item) {
      this.currentItem = item
      /* const info = this.dataList.find(item => item.id === this.currentItem.datasetId)
      this.dataSetInfo = info */
      this.$router.push({ name: 'subTask', query: { parentId: item.id } })
    }
  }
}
</script>
<style>

</style>
